module.exports = __webpack_public_path__ + "img/image4.bf78e790.png";